// extracted by mini-css-extract-plugin
module.exports = {"component":"ProjectSelect_component__2UpLj","readOnly":"ProjectSelect_readOnly__18ebq","downdownIcon":"ProjectSelect_downdownIcon__1z9sE","icon":"ProjectSelect_icon__1rX0S"};